import React, { Component } from "react";
import PropTypes from "prop-types";
import InlineSVG from "svg-inline-react";
import { DESIGN } from "../assets/svg";
import styled from "styled-components";
import { RollFromLeft, Marquee } from "../ui/animations";

const SVGCarouselContainer = styled.span`
  position: ${({ relative }) => (relative ? "relative" : "absolute")};
  left: ${({ left }) => left || "-6.5%"};
  top: ${({ right }) => right || "26%"};
  opacity: ${({ opacity }) => (opacity ? "1" : "0.4")};
  overflow-x: hidden;
  color: #fff000;
  animation: ${Marquee} 33.75s ease infinite;
  svg {
    max-width: 120%;
  }
`;

class SVGCarousel extends Component {
  static propTypes = {
    items: PropTypes.array,
    duration: PropTypes.number
  };

  static defaultProps = {
    items: [DESIGN, DESIGN],
    duration: 4000
  };

  constructor() {
    super();
    this.state = {
      svgIndex: 0
    };
    this.toggleSvgs = this.toggleSvgs.bind(this);
  }

  toggleSvgs() {
    setInterval(() => {
      const { items } = this.props;
      if (this.state.svgIndex < items.length - 1) {
        this.setState({ svgIndex: this.state.svgIndex + 1 });
      } else {
        this.setState({ svgIndex: 0 });
      }
    }, this.props.duration);
  }

  componentDidMount() {
    // this.toggleSvgs();
  }

  render() {
    const { items } = this.props;
    return (
      <SVGCarouselContainer {...this.props}>
        <InlineSVG src={items[this.state.svgIndex]} />
      </SVGCarouselContainer>
    );
  }
}

export default SVGCarousel;
